import type { NavigateFunction } from 'react-router-dom';

let navigateRef: NavigateFunction | null = null;

export const setNavigateRef = (nav: NavigateFunction) => {
  navigateRef = nav;
};

export const appNavigate = (to: string, options?: { replace?: boolean }) => {
  if (navigateRef) {
    navigateRef(to, options);
  } else {
    window.location.href = to;
  }
};
